export default {
  'productiveHoursCost.form.costPerEmployee': 'Cost per employee (%)',

  'productiveHoursCost.form.filterByDate': 'Filter by date',
  'productiveHoursCost.form.filterByDate.entrance': 'Entrance',
  'productiveHoursCost.form.filterByDate.authorization': 'Authorization',
  'productiveHoursCost.form.filterByDate.shutdown': 'Shutdown',
  'productiveHoursCost.form.filterByDate.exit': 'Exit',

  'productiveHoursCost.form.situation': 'Situation',
  'productiveHoursCost.form.situation.open': 'Open',
  'productiveHoursCost.form.situation.authorized': 'authorized',
  'productiveHoursCost.form.situation.closed': 'Closed',
  'productiveHoursCost.form.situation.canceled': 'Canceled',

  'productiveHoursCost.form.type': 'Type',
  'productiveHoursCost.form.type.workOrder': 'WorkOrder',
  'productiveHoursCost.form.type.warranty': 'Warranty',
  'productiveHoursCost.form.type.return': 'Return',
  'productiveHoursCost.form.type.courtesy': 'Courtesy',
  'productiveHoursCost.form.type.insideCourtesy': 'Inside (Courtesy)',
  'productiveHoursCost.form.type.totalLoss': 'Total Loss',
  'productiveHoursCost.form.type.revision': 'Revision',

  'productiveHoursCost.form.moreOption.employees': 'Employees',
  'productiveHoursCost.form.moreOption.area': 'Area',
};
